import { render, staticRenderFns } from "./ColorBubble.vue?vue&type=template&id=785d4d2f&scoped=true&"
import script from "./ColorBubble.vue?vue&type=script&lang=js&"
export * from "./ColorBubble.vue?vue&type=script&lang=js&"
import style0 from "./ColorBubble.vue?vue&type=style&index=0&id=785d4d2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../order-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785d4d2f",
  null
  
)

export default component.exports